import React, { useContext } from 'react';
import UserProvider from '../../context/UserContext';
import '../../dash.css'
import { useAlert } from "react-alert";

const CardAccount = () => {
    const alert = useAlert();
    const Data = useContext(UserProvider.context);
    const memberData = Data.member
    let isCustomer = memberData.stripe_customer

    function alertError(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.error(message)
        }
    }

    function ShowEmailCard(){
        var x = document.getElementById("email");
        if (x.style.display === "flex") {
            x.style.display = "none";
        } else {
            x.style.display = "flex";
        }

        var y = document.getElementById("overlay");
        if (y.style.display === "flex") {
            y.style.display = "none";
        } else {
            y.style.display = "flex";
        }
    }

    function downloadInfinit(){
        if(document.getElementById('download-infinit').disabled === false){
            document.getElementById('download-infinit').disabled = true;
            setTimeout(() => {
                let url; 
                if(memberData.download == null){
                    url = 'https://cdn.discordapp.com/attachments/702512879710240779/719592345783369839/Infinit.zip'
                }
                else{
                    url = memberData.download
                }
                window.open(url)
            }, 10)
            document.getElementById('download-infinit').disabled = false;
        }
    }

    function manageSuscription(){
        if(document.getElementsByClassName('manage')[0].disabled === false){
            document.getElementsByClassName('manage')[0].disabled = true;
            const url = `${process.env.REACT_APP_API_URL}/stripe-session/`

            fetch(url, {
                credentials: "include",
                method: 'GET',
                })
                .then(function (response) {
                    if(response.status === 200){
                        response.json().then(function(data){
                            window.location.replace(data.url)
                        })    
                    }
                    else{
                        alertError("Internal Error")
                    }
                    document.getElementsByClassName('manage')[0].disabled = false;
                })
                .catch(err => {
                    alertError("Internal Error")
                    document.getElementsByClassName('manage')[0].disabled = false;
                    console.log(err)
                });
        }
    }


    return(
        <div className="card-component">
            <div className="card-content">
                <div>
                <h4 className="card-title">Account</h4>
                    <div>
                        <button id="download-infinit"className="card-button" onClick={downloadInfinit}>
                            <h5><i className="fas fa-download"></i>Download Infinit</h5>
                        </button>
                    </div>
                    <div>
                        <button className="card-button" onClick={ShowEmailCard}>
                            <h5><i className="fas fa-at"></i>Update e-mail</h5>
                        </button>
                    </div>
                    {
                        isCustomer &&
                        <div>
                            <button className="card-button manage" onClick={manageSuscription}>
                                <h5><i className="far fa-credit-card"></i>Manage subscription</h5>
                            </button>
                        </div>
                    }
                    {
                        /*
                    <div>
                        <button className="card-button">
                            <h5><i className="fas fa-ban"></i>Cancel membership</h5>
                        </button>
                    </div>
                    */}   
                </div>
            </div>
        </div>
        
  
    )
};

export default CardAccount;